import React, { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import { useAuth } from "../../../context/AuthProvider";
import axios from "axios";
import { getOS } from "../../../utils/getOs";
import { usePermission } from "../../../context/PermissionContext";
import { CheckIcon, DownloadIcon, ErrorCircleIcon, RefreshIcon } from "../../../constants/Icons";

const PrinterControl = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isPaperSize, setPaperSize] = useState("A4");
  const [settingData, setSettingsData] = useState(null);
  const { storeSettings } = usePermission();
  const { updateSettings } = useAuth();
  const [isCheckLoad, setIsCheckLoad] = useState(false);
  const [error, setError] = useState("");
  const [printerName, setPrinterName] = useState("");
  const [loading, setLoading] = useState(false);
  const os = getOS();
  // console.log(os)
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const initialPaperSize = settingData?.printerSettings?.paperSize || "A4";
  const hasChanges = isPaperSize !== initialPaperSize;

  const toggleItems = [
    {
      key: "printThrough",
      label: "Direct Print",
      icon: "bx bx-printer",
      settingLable: "printThrough",
      color: "gray",
      subtext:
        "Enable this You can print the invoice Dirct Through the Printer ",
    },
  ];
  const initialToggleState = toggleItems.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});

  const [toggles, setToggles] = useState(initialToggleState);
  const handleToggleUpdate = async (value, key, settingLable) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    try {
      if (!checkNetwork()) return;

      const data = {
        printSystemSettings: {
          [settingLable]: value,
        },
      };

      const response = await AxiosInstance.patch(`module/storesettings`, data);
      const savedSettings = response.data?.results?.printSystemSettings || {};
      if (Object.prototype.hasOwnProperty.call(savedSettings, settingLable)) {
      showAlert("success", response.data.message);
      // setPrinterName(
      //   response.data.results?.storeSettings?.printSystemSettings?.printerName
      // );
      updateSettings({
        storeSettings: {
          printSystemSettings: {
            ...storeSettings?.printSystemSettings,
            [settingLable]: value,
          },
        },
      });
      setToggles((prev) => ({ ...prev, [key]: value }));
    }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  const validatePrinterName = (name) => {
    if (!name) return "Printer name is required";

    if (name.length < 3) return "Minimum 3 characters required";

    if (name.length > 50) return "Maximum 50 characters allowed";

    const regex = /^[a-zA-Z0-9() _-]+$/;

    if (!regex.test(name))
      return "Only letters, numbers, space, _ and - are allowed";

    return "";
  };

  const handleAddName = async () => {
    const value = printerName?.trim(); //  use trimmed value

    const validationError = validatePrinterName(value);

    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      if (!checkNetwork()) return;

      const data = {
        printSystemSettings: {
          printerName: value, //  use trimmed value
        },
      };

      const response = await AxiosInstance.patch(`module/storesettings`, data);

      updateSettings({
        storeSettings: {
          printSystemSettings: {
            ...storeSettings?.printSystemSettings,
            printerName: value,
          },
        },
      });

      setPrinterName(value); //  sync back
      setError(""); //  clear error

      showAlert("success", Messages.SUCCESS.SETTINGS_UPDATED);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handlePrinterChange = (e) => {
    const value = e.target.value;
    setPrinterName(value);

    // only validate if error already shown
    if (error) {
      setError(validatePrinterName(value.trim()));
    }
  };

  const handleSwitchChange = (event, key, settingLable) => {
    const newValue = event.target.checked;
    handleToggleUpdate(newValue, key, settingLable);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddName();
    }
  };
  const handleUpdate = async () => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      var data = {
        printerSettings: {
          paperSize: isPaperSize,
        },
      };
      const response = await AxiosInstance.patch(`module/storesettings`, data);
      setSettingsData(response.data.results);
      setPaperSize(response.data.results?.printerSettings?.paperSize || "A4");
      updateSettings({
        storeSettings: {
          printerSettings: {
            paperSize: isPaperSize,
          },
        },
      });
      showAlert("success", Messages.SUCCESS.SETTINGS_UPDATED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleDownload = () => {
    window.open(
      "https://storage.googleapis.com/live-negobill-storage/printSetup/NegoBillPrintServiceSetup_1_0_0.exe",
      "_self"
    );
  };

  const handleCheckPrintService = async () => {
    try {
      if (!checkNetwork()) return;
      setIsCheckLoad(true);
      const response = await axios.get("http://127.0.0.1:9164/ping", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = response.data;
      if (result) {
        showAlert("success", "NegoBill Print Service is Active and Running..");
      }
    } catch (error) {
      showAlert("error", "NegoBill Print Service Not Actived");
      return null;
    } finally {
      setIsCheckLoad(false);
    }
  };
  const handleView = async () => {
    setIsLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/storesettings`);
      const printSystemSettings =
        response.data?.results?.printSystemSettings || {};
      setSettingsData(response.data.results);
      setPaperSize(response.data.results?.printerSettings?.paperSize || "A4");
      setPrinterName(printSystemSettings?.printerName);
      const updatedToggles = {};
      toggleItems.forEach((item) => {
        updatedToggles[item.key] =
          printSystemSettings[item?.settingLable] || false;
      });
      setToggles(updatedToggles);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaperSize = (e) => {
    const { value } = e.target;
    setPaperSize(value);
  };

  useEffect(() => {
    handleView();
  }, []);

  return (
    <Box position="relative">
      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bgcolor="rgba(255, 255, 255, 0.5)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={1000}
        >
          <CircularProgress size={22} />
        </Box>
      )}
      <div className="card">
        <div className="card-header p-3 bg-light-core">
          <h6 className="mb-0 text-dark">Printer Settings</h6>
        </div>
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="fw-medium mb-1">Print Paper Size</div>
              <div className="fs-12 fw-normal mb-2">
                Choose the paper size you wish to use for printing receipts.
              </div>
            </div>
            <div className="col-lg-4">
              <select
                className="form-select"
                onChange={handlePaperSize}
                value={isPaperSize}
                autoFocus
              >
                <option value="A4">A4</option>
                <option value="HALFA4">A5</option>
                <option value="2INCH">2 Inch</option>
                <option value="3INCH">3 Inch</option>
                <option value="4INCH">4 Inch</option>
              </select>
            </div>
          </div>
        </div>
        <div className="card-footer p-3 border-0">
          {isBtnLoading ? (
            <button className="btn btn-primary pb-0 text-right" disabled>
              <CircularProgress size={22} className="text-white" />
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-primary text-right"
              onClick={handleUpdate}
              disabled={!hasChanges}
            >
              <CheckIcon/> Save Changes
            </button>
          )}
        </div>
      </div>
      {/* {os==="Windows" &&( */}
      <div className="row">
        <div className="col-12">
          <div className="card radius-10 mb-0">
            <div className="card-body p-3">
              <span className="d-flex justify-content-between fw-medium">
                <span>NegoBill Print System</span>
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleCheckPrintService}
                    title="Check"
                    disabled={isCheckLoad}
                  >
                    <RefreshIcon iClass={`${
                        isCheckLoad ? "bx-spin" : ""
                      }`}/>
                    Check
                  </button>
                </div>
              </span>
              <div className="my-2">
                <p class="text-gray-600 mb-0">
                  Download the NegoBill Print Utility to enable direct printing
                  from your browser to your thermal printer.
                </p>
                <p class="text-xs text-gray-400 italic">
                  Compatible with Windows 10/11
                </p>
              </div>
              <div className="d-flex justify-content-between align-items-end flex-wrap gap-3">
                {/* LEFT SIDE */}
                <div className="d-flex flex-column gap-2 w-60">
                  <div className="p-2 border bg-primary rounded">
                    <strong>Tip:</strong> After installing, ensure the
                    application is running in your Windows System Tray (near the
                    clock).
                  </div>

                  {/* NEW SETTINGS */}
                  <div className="border rounded p-2 bg-light">
                    {/* Print Through */}
                    <div className="col-lg-12">
                      {toggleItems.map(
                        ({
                          key,
                          label,
                          icon,
                          color,
                          settingLable,
                          subtext,
                        }) => (
                          <div key={key} className="d-flex align-items-center">
                            <div>
                              <i
                                className={`${icon} font-27`}
                                style={{ color: toggles[key] ? color : "gray" }}
                              ></i>
                            </div>
                            <div className="flex-grow-1 ms-2">
                              <label className="mb-0">
                                {label}
                                <span className="tooltip-container ms-1">
                                  <span className="cursor-poInter">
                                    <ErrorCircleIcon/>{" "}
                                  </span>
                                  <span
                                    className="tooltip-text"
                                    style={{ zIndex: 10 }}
                                  >
                                    {subtext}
                                  </span>
                                </span>
                              </label>
                            </div>
                            <div className="ms-auto custom-toggle-wrapper">
                              <label className="custom-toggle">
                                <input
                                  type="checkbox"
                                  id={`${key}Toggle`}
                                  checked={toggles[key]}
                                  onChange={(event) =>
                                    handleSwitchChange(event, key, settingLable)
                                  }
                                  disabled={loading[key]}
                                />
                                <span className="slider cursor-poInter">
                                  {loading[key] ? (
                                    <span
                                      className={`spinner-inside ${
                                        toggles[key] ? "spinner-right" : ""
                                      }`}
                                    />
                                  ) : (
                                    <>
                                      {toggles[key] ? (
                                        <span className="label-on ms-0-1">
                                          ON
                                        </span>
                                      ) : (
                                        <span className="label-off ms-3">
                                          OFF
                                        </span>
                                      )}
                                    </>
                                  )}
                                </span>
                              </label>
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    {/* Printer Name */}
                    <div className="mb-2">
                      <label htmlFor="printerName" className="form-label">
                        {" "}
                        Printer name{" "}
                      </label>
                      <div className="d-flex gap-2">
                        <input
                          type="text"
                          className="form-control"
                          name="printerName"
                          autoComplete="off"
                          value={printerName}
                          onChange={handlePrinterChange}
                          onKeyDown={handleKeyDown}
                        />
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleAddName}
                        >
                          <CheckIcon/>
                        </button>
                      </div>
                      {error && <div className="invalid-feedback">{error}</div>}
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleDownload}
                >
                  <DownloadIcon/>{" "}
                  NegoBillPrintServiceSetup_1_0_0.exe
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </Box>
  );
};

export default PrinterControl;
